import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Select_DashSearchResultLabels } from "@mirage/analytics/events/types/select_dash_search_result_labels";
import { useAtom } from "jotai";
import { AnnotationURLModal } from "./AnnotationURLModal";
import { showMissingUrlsModal } from "./atoms";
export const AnnotationsConfirmation = ({
  searchRequestId,
  query,
}: {
  searchRequestId?: string;
  query: string;
}) => {
  const [showURLModal, setShowURLModal] = useAtom(showMissingUrlsModal);
  const { reportPapEvent, searchAttemptSessionManager, searchSessionManager } =
    useMirageAnalyticsContext();

  const handleSubmitURL = (url: string) => {
    reportPapEvent(
      PAP_Select_DashSearchResultLabels({
        queryString: query,
        searchSessionId: searchSessionManager.getSessionIdOrUndefined(),
        searchAttemptId: searchAttemptSessionManager.getSessionIdOrUndefined(),
        searchRequestId,
        goldenResult: url,
        featureLine: "search",
      }),
    );
  };

  return (
    <AnnotationURLModal
      isOpen={showURLModal}
      onClose={() => setShowURLModal(false)}
      onSubmitURL={handleSubmitURL}
    />
  );
};
